module.exports = "data:image/vnd.microsoft.icon;base64,"